export type TimezoneGroup = {
  region: string;
  zones: readonly string[];
};

export const COMPANY_TIMEZONE_GROUPS: readonly TimezoneGroup[] = [
  {
    region: "Asia",
    zones: [
      "Asia/Karachi",
      "Asia/Dubai",
      "Asia/Riyadh",
      "Asia/Qatar",
      "Asia/Kuwait",
      "Asia/Bahrain",
      "Asia/Muscat",
      "Asia/Tehran",
      "Asia/Kabul",
      "Asia/Tashkent",
      "Asia/Almaty",
      "Asia/Bishkek",
      "Asia/Dhaka",
      "Asia/Kolkata",
      "Asia/Colombo",
      "Asia/Kathmandu",
      "Asia/Yangon",
      "Asia/Bangkok",
      "Asia/Jakarta",
      "Asia/Kuala_Lumpur",
      "Asia/Singapore",
      "Asia/Hong_Kong",
      "Asia/Shanghai",
      "Asia/Taipei",
      "Asia/Seoul",
      "Asia/Tokyo",
      "Asia/Manila",
      "Asia/Ho_Chi_Minh",
    ],
  },
  {
    region: "Europe",
    zones: [
      "Europe/London",
      "Europe/Dublin",
      "Europe/Paris",
      "Europe/Berlin",
      "Europe/Rome",
      "Europe/Madrid",
      "Europe/Amsterdam",
      "Europe/Brussels",
      "Europe/Vienna",
      "Europe/Zurich",
      "Europe/Prague",
      "Europe/Warsaw",
      "Europe/Budapest",
      "Europe/Bucharest",
      "Europe/Athens",
      "Europe/Helsinki",
      "Europe/Istanbul",
      "Europe/Kyiv",
      "Europe/Moscow",
      "Europe/Lisbon",
      "Europe/Copenhagen",
      "Europe/Oslo",
      "Europe/Stockholm",
    ],
  },
  {
    region: "America",
    zones: [
      "America/New_York",
      "America/Chicago",
      "America/Denver",
      "America/Phoenix",
      "America/Los_Angeles",
      "America/Anchorage",
      "America/Honolulu",
      "America/Toronto",
      "America/Vancouver",
      "America/Mexico_City",
      "America/Bogota",
      "America/Lima",
      "America/Santiago",
      "America/Sao_Paulo",
      "America/Buenos_Aires",
    ],
  },
  {
    region: "Africa",
    zones: [
      "Africa/Cairo",
      "Africa/Johannesburg",
      "Africa/Lagos",
      "Africa/Nairobi",
      "Africa/Casablanca",
      "Africa/Algiers",
      "Africa/Khartoum",
    ],
  },
  {
    region: "Australia & Pacific",
    zones: [
      "Australia/Sydney",
      "Australia/Melbourne",
      "Australia/Brisbane",
      "Australia/Perth",
      "Australia/Adelaide",
      "Australia/Darwin",
      "Pacific/Auckland",
      "Pacific/Fiji",
      "Pacific/Guam",
      "Pacific/Honolulu",
    ],
  },
] as const;

export const ALL_COMPANY_TIMEZONES: readonly string[] = COMPANY_TIMEZONE_GROUPS.flatMap((g) => g.zones);

export function formatTimezoneLabel(tz: string): string {
  return tz.replace(/_/g, " ");
}

export function timezoneKeywords(tz: string, region: string): string[] {
  const city = tz.includes("/") ? tz.split("/").pop() ?? tz : tz;
  return [tz, region, city, formatTimezoneLabel(tz), formatTimezoneLabel(city)].map((s) => s.toLowerCase());
}

export function isKnownCompanyTimezone(tz: string): boolean {
  const t = tz.trim();
  return Boolean(t && ALL_COMPANY_TIMEZONES.includes(t));
}
